import type { WidgetSettingsResponse } from '../types/widget-settings.js';

/** Playground / e2e: `VITE_TEO_REENGAGE_SMOKE=true` exercises first_dialog_reengage. */
function isReengageSmoke(): boolean {
  try {
    const env = (import.meta as { env?: Record<string, string | undefined> })
      .env;
    return (
      env?.VITE_TEO_REENGAGE_SMOKE === 'true' ||
      env?.VITE_TEO_REENGAGE_SMOKE === '1'
    );
  } catch {
    return false;
  }
}

/**
 * Example settings from Yeremchuk Dental + proposed new keys.
 * Use in playground and Storybook.
 */
export const MOCK_WIDGET_SETTINGS: WidgetSettingsResponse = {
  BS_BG_COLOR_MESSAGES: '#2BBBB5',
  BS_BORDER_RADIUS: '50',
  BS_INDENT_FROM_BELOW: '40',
  BS_POPUP_BG_COLOR: '#ffffff',
  BS_POPUP_BUTTON_BG_COLOR: '#4ce3de',
  BS_POPUP_BUTTON_TEXT_COLOR: '#000000',
  BS_POPUP_TEXT_COLOR: '#000000',
  BS_POSITIONING: 'bottom_left',
  BS_MOBILE_LAUNCHER_MODE: 'fixed',
  BS_RETREAT_FROM_EDGE: '40',
  BS_SIZE: '56',
  BS_TEXT_COLOR: '#ffffff',

  WS_BG_COLOR: '#ECEFF2',
  WS_BG_COLOR_HEADER: '#2bbbb5',
  WS_BG_COLOR_MESSAGES: '#4ce3de',
  WS_BG_COLOR_USER_MESSAGES: '#e8f7f6',
  WS_BORDER_RADIUS: '16',
  WS_FONT_FAMILY: 'Arial, sans-serif',
  WS_TEXT_COLOR: '#282828',
  WS_TEXT_COLOR_HEADER: '#282828',
  WS_TEXT_COLOR_MESSAGES: '#1a1a1a',
  WS_TEXT_COLOR_USER_MESSAGES: '#1a1a1a',
  WS_WIDGET_SIZE: 'small',

  CONTEXT_ENABLED: 'true',
  WIDGET_VISIBLE: 'true',
  PROACTIVE_GREETING_ENABLED: 'true',
  LANGUAGES: 'uk,en',
  MESSAGE_SCHEDULE:
    '{"1":[{"start":"00:00","end":"23:59"}],"2":[{"start":"00:00","end":"23:59"}],"3":[{"start":"00:00","end":"23:59"}],"4":[{"start":"00:00","end":"23:59"}],"5":[{"start":"00:00","end":"23:59"}],"6":[{"start":"00:00","end":"23:59"}],"7":[{"start":"00:00","end":"23:59"}]}',
  SHOP_NAME: 'Yeremchuk Dental Chat',
  URL: 'https://example.com/widget',
  WELCOME_MESSAGE: JSON.stringify({
    uk: 'Вітаємо на сторінці стоматології Yeremchuk Dental.\nМене звати Марія.\nЯ з відділу турботи. Чим я можу допомогти?',
    en: 'Welcome to Yeremchuk Dental.\nMy name is Maria.\nHow can I help you today?',
  }),

  EXIT_INTENT_MESSAGE: JSON.stringify({
    uk: 'Зачекайте! Маєте питання щодо послуг? Напишіть нам — відповімо за хвилину.',
    en: 'Wait! Have questions about our services? Message us — we reply within a minute.',
  }),

  AI_AGENT_NAME: 'Марія',
  AI_AVATAR_URL: '',
  CONTEXT_POPUP_DELAY_SECONDS: '15',
  CONTEXT_POPUP_DELAY_BY_PAGE_TYPE: JSON.stringify({
    home: 10,
    category: 14,
    product: 12,
    cart: 14,
    checkout: 5,
    blog: 20,
    search: 15,
    other: 15,
  }),
  PROACTIVE_GREETING_AUTO_OPEN_CHAT: 'false',
  PROACTIVE_GREETING_QUICK_REPLIES: 'false',
  PROACTIVE_GREETING_QUICK_REPLY_COUNT: '3',
  PROACTIVE_GREETING_QUICK_REPLY_SOURCE: 'ai',
  PROACTIVE_GREETING_CUSTOM_QUICK_REPLY: JSON.stringify({
    uk: 'Підкажіть, будь ласка',
    en: 'Please help me',
  }),
  // Default mock matches production mode so playground exercises the real cycle.
  // `VITE_TEO_REENGAGE_SMOKE` shortens the wait to 60s and starts without thread_id.
  PROACTIVE_GREETING_MODE: 'first_dialog_reengage',
  PROACTIVE_GREETING_REENGAGE_SECONDS: isReengageSmoke() ? '60' : '1800',
  POWERED_BY_ENABLED: 'true',
  POWERED_BY_TEXT: '',
  POWERED_BY_URL: 'https://teo.ai',
};
